import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ConfigService } from '../shared/config.service';
import { PlanningEspace } from '../model/planningEspace.model';
import { PlanningDTO } from '../model/planningDTO.model';
import { SearchResaCriteria } from '../model/searchresacriteria.model';
import { Planning } from '../model/planning.model';
import { PlanningMultiple } from '../model/planningMultiple.model';
import { IdPlanning } from '../model/idplanning.model';
import {MembrePlanningEspace} from '../model/membrePlanningEspace.model';

@Injectable()
export class PlanningService {
  _baseUrl: string ='';
  _planningDelete = new Subject<Boolean>();

  constructor(private http: Http,
              private configService: ConfigService) {
        this._baseUrl = configService.getApiURI();

  }

  getAll(datedebut: string, espaceId: string, idutilisateur: string): Observable<PlanningEspace[]> {
    let cpHeaders = new Headers({'Content-Type': 'application/json' });
    let cpParams = new URLSearchParams();
    cpParams.set('datedebut', datedebut);
    cpParams.set('espaceId', espaceId);
	cpParams.set('idutilisateur', idutilisateur);
    let options = new RequestOptions({ headers: cpHeaders, params: cpParams });
    return this.http.get(this._baseUrl + 'planning/all', options)
        .map((res: Response) => {
                     // console.log(res.json());
          return res.json();
        })
        .catch(this.handleError);
  }

  getAllResa(datedebut: string): Observable<PlanningDTO[]> {
    let cpHeaders = new Headers({ 'Content-Type': 'application/json' });
    let cpParams = new URLSearchParams();
    cpParams.set('datedebut', datedebut);

    let options = new RequestOptions({ headers: cpHeaders, params: cpParams });
    return this.http.get(this._baseUrl + 'planning/resa', options)
        .map((res: Response) => {
                     // console.log(res.json());
          return res.json();
        })
        .catch(this.handleError);
  }

  getAllUser(datedebut: string, utilisateurId: string): Observable<Planning[]> {
    let cpHeaders = new Headers({ 'Content-Type': 'application/json' });
    let cpParams = new URLSearchParams();
    cpParams.set('datedebut', datedebut);
    cpParams.set('utilisateurId', utilisateurId);
    let options = new RequestOptions({ headers: cpHeaders, params: cpParams });
    return this.http.get(this._baseUrl + 'planning/alluser', options)
        .map((res: Response) => {
                     // console.log(res.json());
          return res.json();
        })
        .catch(this.handleError);
  }

  get(id: string) : Observable<Planning> {
    let cpHeaders = new Headers({ 'Content-Type': 'application/json' });
    let cpParams = new URLSearchParams();
    cpParams.set('id', id);
    let options = new RequestOptions({ headers: cpHeaders, params: cpParams });
    return this.http.get(this._baseUrl + 'planning/get', options)
          .map((res: Response) => {
     // console.log(res.json());
              return res.json();
          })
          .catch(this.handleError);

  }

  create(planning: Planning): Observable<Planning> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

      return this.http.post(this._baseUrl + 'planning/create', planning, options)
            .map((res: Response) => {

                return res.json();
            })
            .catch(this.handleError);
  }

  uploadPlanning(inputFile: any): Promise<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'multipart/form-data');
    const options = new RequestOptions({ headers: headers });
    const formData = new FormData();
    formData.append('file', inputFile);
    // console.log('formData', formData.get('file'));
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', this._baseUrl + 'upload', true);
      xhr.send(formData);
      xhr.onreadystatechange = function () {
        // console.log(xhr.readyState, xhr.status);
        if (xhr.status == 200) {
          resolve(xhr.responseText);
        } else {
          reject('error');
        }
      }
    })

      // return this.http.post(this._baseUrl + 'upload', formData)
      //       .map((res: Response) => {
      //
      //           return res;
      //       })
      //       .catch(this.handleError);
  }


  delete(id: string) {
    let cpHeaders = new Headers({ 'Content-Type': 'application/json' });
    let cpParams = new URLSearchParams();
    cpParams.set('id', id);
    let options = new RequestOptions({ headers: cpHeaders, params: cpParams });

    //console.log(options.params);
    return this.http.delete(this._baseUrl + 'planning/delete', options)
            .map(success => success.status)
            .catch(this.handleError);

  }

  search(searchResaCriteria: SearchResaCriteria): Observable<PlanningDTO[]> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

      return this.http.post(this._baseUrl + 'planning/search', searchResaCriteria, options)
            .map((res: Response) => {
                return res.json();
            })
            .catch(this.handleError);
  }


  private handleError(error: any) {
    var applicationError = error.headers.get('Application-Error');
   // var serverError = error.json();
    var modelStateErrors: string = '';

    //if (!serverError.type) {
    //    console.log(serverError);
    //    for (var key in serverError) {
    //        if (serverError[key])
    //            modelStateErrors += serverError[key] + '\n';
    //    }
   // }

    modelStateErrors = modelStateErrors = '' ? null : modelStateErrors;

    return Observable.throw(applicationError || modelStateErrors || 'Server error');
  }

  getPdfPlanning() {
    return this.http.get(this._baseUrl + 'docplanning/download')
      .map(success => success.status)
      .catch(this.handleError);
  }

  createMultiple(planningMultiple: PlanningMultiple): Observable<boolean> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

      return this.http.post(this._baseUrl + 'planning/create', planningMultiple, options)
            .map((res: Response) => {
                return res.json();
            })
            .catch(this.handleError);
  }

  removePlanning(planningMultiple: PlanningMultiple): Observable<boolean> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

      return this.http.post(this._baseUrl + 'planning/cancel-planning', planningMultiple, options)
            .map((res: Response) => {
                return res.json();
            })
            .catch(this.handleError);
  }

  deleteMultiple(idplanning: IdPlanning): Observable<boolean> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

      return this.http.post(this._baseUrl + 'planning/deletemultiple', idplanning, options)
            .map((res: Response) => {
                //return res.json();
            })
            .catch(this.handleError);
  }

  getEspaceClientbyPere(idpere: string, dateDebut: string, idespace: string ): Observable<MembrePlanningEspace[]> {
    let cpHeaders = new Headers({ 'Content-Type': 'application/json' });
    let cpParams = new URLSearchParams();
    cpParams.set('idclient', idpere);
	cpParams.set('idespace', idespace);
	cpParams.set('datedebut', dateDebut);
    let options = new RequestOptions({ headers: cpHeaders, params: cpParams });
    return this.http.get(this._baseUrl + 'planning/membreplanning', options)
        .map((res: Response) => {
                     // console.log(res.json());
          return res.json();
        })
        .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/service/planning.service.ts